import { observer } from 'mobx-react-lite'
import { getFullAddress, getHeight, getPhone, getWeight } from 'util/apiFieldFormatters'
import capitalize from 'lodash/capitalize'
import DetailsSection from '../common/DetailsSection'
import DetailsValue from '../common/DetailsValue'
import { formatDate } from 'util/formatters'

type GeneralSectionProps = {
  // TODO: improve visit type
  visit: any
}

const GeneralSection = ({ visit }: GeneralSectionProps) => {
  const { memberExtendedData, isSuccess } = visit

  if (!memberExtendedData) {
    return null
  }
  const {
    addresses,
    phones,
    dob,
    degreeClassification,
    pronoun,
    graduationSemester,
    graduationYear,
    gender,
    genderIdentity,
  } = memberExtendedData.privateData.member
  const { heightFt, heightIn, weightLbs } = memberExtendedData.privateData.medicalHistory

  // TODO - improve type
  // @ts-ignore
  const { street, state } = getFullAddress(addresses, 'extended')
  const patientPhone = getPhone(phones)

  const emptyValue = 'Not Answered'

  return (
    <DetailsSection title="GENERAL">
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-x-6 gap-y-4">
        <DetailsValue label="Address" value={[street, state, patientPhone].filter(Boolean).join('\n')} />
        <DetailsValue label="Date of Birth" value={formatDate(dob)} />
        {!isSuccess && (
          <>
            <DetailsValue label="Weight" value={getWeight(weightLbs)} />
            <DetailsValue label="Height" value={getHeight(heightFt, heightIn)} />
          </>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-x-6 gap-y-4">
        <DetailsValue label="Preferred Pronoun" value={pronoun} emptyValue={emptyValue} />
        <DetailsValue label="Sex" value={gender} emptyValue={emptyValue} />
        <DetailsValue label="Gender" value={genderIdentity} emptyValue={emptyValue} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-x-6 gap-y-4">
        <DetailsValue label="Classification" emptyValue={emptyValue} value={capitalize(degreeClassification)} />
        <DetailsValue label="Graduation Year" emptyValue={emptyValue} value={graduationYear} />
        <DetailsValue label="Graduation Semester" emptyValue={emptyValue} value={graduationSemester} />
      </div>
    </DetailsSection>
  )
}

export default observer(GeneralSection)
